<template>
  <el-dialog
    :title="$t('comp.per.admin_users.text1')"
    :visible.sync="dialogUser"
    @close="handleClose()"
  >
    <span> {{ $t('comp.per.admin_users.text2') }} </span><br /><br />
    <el-select
      @change="selectAllFromSelect('userForm.id', users)"
      multiple
      collapse-tags
      clearable
      class="select-primary custom-width-select shadow-sm required-users mb-4"
      v-model="userForm.id"
      filterable
      :placeholder="$t('comp.per.admin_users.text3')"
    >
      <el-option
        v-for="option in users"
        class="select-primary selected-all"
        :value="option.id"
        :label="option.name"
        :key="option.id"
      >
      </el-option>
    </el-select>
    <span slot="footer" class="dialog-footer">
      <button class="btn btn-danger mb-4" @click="handleClose()">
        {{ $t('common_words.cancel') }}</button
      >&nbsp;
      <button class="btn btn-success mb-4" @click="changeUsers()">
        {{ $t('common_words.confirm') }}
      </button>
    </span>
  </el-dialog>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import MixinMasters from 'src/util/mixinMasters';

export default {
  name: 'admin-users',
  mixins: [MixinMasters],
  props: {
    initialValue: {
      type: Object,
      default: () => {
        return {};
      },
    },
    users: {
      type: Array,
      default: () => {
        return [];
      },
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.dialogUser = newValue;
      }
    },
    initialValue(newValue) {
      if (newValue.users_old) {
        this.userForm = { ...this.userForm, ...newValue };
      }
    },
  },
  data() {
    return {
      userForm: {
        id: null,
      },
      dialogUser: false,
    };
  },
  methods: {
    /**
     * Ejecuta en el padre el método para cerrar el dialogo
     */
    handleClose() {
      this.dialogUser = false;
      this.$emit('closeAdminUsers');
    },

    /**
     * Método para ejecutar el cambio de usuarios de un permiso con el
     * servicio habilitado para la tarea
     */
    changeUsers() {
      this.showHideLoading(true);
      this.userForm.route = 'permissions/updatepermissionsuser';
      Axios.postMasters(this.userForm)
        .then((response) => {
          this.$emit('successChangeUser', response);
          this.handleClose();
          this.showHideLoading();
        })
        .catch((error) => {
          this.$emit('catchChangeUser', error);
        });
    },
  },
};
</script>

<style></style>
